import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress PayPal SDK cssRules error - known bug in @paypal/react-paypal-js
// This error occurs when PayPal tries to access cross-origin stylesheets
const originalError = console.error;
console.error = (...args) => {
  const errorString = args[0]?.toString?.() || '';
  if (errorString.includes('cssRules')) {
    return;
  }
  originalError.apply(console, args);
};

// Suppress from window.onerror (catches runtime errors before React overlay)
const originalOnError = window.onerror;
window.onerror = function(message, source, lineno, colno, error) {
  if (message?.includes?.('cssRules') || error?.message?.includes?.('cssRules')) {
    return true; // Prevents the error from propagating
  }
  if (originalOnError) {
    return originalOnError(message, source, lineno, colno, error);
  }
  return false;
};

// Handle error events (capture phase to catch before React)
window.addEventListener('error', (event) => {
  if (event.message?.includes?.('cssRules') || 
      event.error?.message?.includes?.('cssRules')) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    return true;
  }
}, true);

// Handle unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason?.message?.includes?.('cssRules')) {
    event.preventDefault();
    return true;
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
